// ============================================================================
// FSA STATEMENTS ENDPOINTS  (FSA-2.2 Wave 3 Statement save)
// ============================================================================
//
// Backend controller: FsaStatementsController → [Route("api/v1/[controller]")]
// Resolves to /api/v1/FsaStatements — BASE_PATH MUST match.

import { buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';

const BASE_PATH = '/FsaStatements';

export const fsaStatementsEndpoints = {
  /** GET /api/v1/FsaStatements/by-engagement/{engId} */
  listByEngagement: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId`, { engId }),

  /** GET /api/v1/FsaStatements/by-engagement/{engId}/{reportId} */
  hydrate: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId`, { engId, reportId }),

  /** PUT /api/v1/FsaStatements/by-engagement/{engId}/{reportId} */
  save: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId`, { engId, reportId }),

  /** POST /api/v1/FsaStatements/by-engagement/{engId}/{reportId}/submit */
  submit: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId/submit`, { engId, reportId }),

  /** POST /api/v1/FsaStatements/by-engagement/{engId}/{reportId}/approve */
  approve: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId/approve`, { engId, reportId }),

  /** POST /api/v1/FsaStatements/by-engagement/{engId}/{reportId}/reopen */
  reopen: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId/reopen`, { engId, reportId }),

  /** FSA-2.4 CF5 — POST /api/v1/FsaStatements/by-engagement/{engId}/{reportId}/import-prior-py */
  importPriorPy: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId/import-prior-py`, { engId, reportId }),

  /** POST /api/v1/FsaStatements/by-engagement/{engId}/{reportId}/exclude (FSA-2.2) */
  exclude: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId/exclude`, { engId, reportId }),

  /** POST /api/v1/FsaStatements/by-engagement/{engId}/{reportId}/include (FSA-2.2) */
  include: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId/include`, { engId, reportId }),

  /** GET /api/v1/FsaStatements/by-engagement/{engId}/{reportId}/preview-pdf?mode=actual|rounded */
  previewPdf: (engId: ID, reportId: ID, mode: 'actual' | 'rounded' = 'actual') =>
    `${buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId/preview-pdf`, { engId, reportId })}?mode=${mode}`,
} as const;

export default fsaStatementsEndpoints;
